<template>
  <div class="scheme_wrap">
    <div class="title_container">
      <div class="title_box">
        <div class="title_1">SOLUTION</div>
        <div class="title_2">解决方案</div>
        <div class="title_3"></div>
      </div>
    </div>

    <!-- grid布局 -->
    <div class="content_container">
      <!-- 左侧详细内容展示区域 -->
      <div class="detail_content" :class="{ 'hidden': hidden}">
        <h3 class="detail_title">{{ currentModule.title }}</h3>
        <div class="detail_description">
          <p class="detail_description_box" v-for="(item, index) in currentModule.description" :key="index">
            {{ item }}
          </p>
        </div>
      </div>

      <!-- 右侧方块网格 -->
      <div class="modules_container">
        <!-- 第一层：三个模块 -->
        <div class="modules_row">
          <div
            v-for="(module, index) in modules.slice(0, 3)"
            :key="index"
            class="module_item"
            @mouseenter="setCurrentModule(module)"
            @mouseleave="resetCurrentModule"
          >
            <div class="module_icon">
              <img :src="module.icon" :alt="module.title" />
            </div>
            <div class="module_title">{{ module.title }}</div>
          </div>
        </div>
        
        <!-- 第二层：两个模块，靠右对齐 -->
        <div class="modules_row modules_row_center">
          <div
            v-for="(module, index) in modules.slice(3, 5)"
            :key="index + 3"
            class="module_item"
            @mouseenter="setCurrentModule(module)"
            @mouseleave="resetCurrentModule"
          >
            <div class="module_icon">
              <img :src="module.icon" :alt="module.title" />
            </div>
            <div class="module_title">{{ module.title }}</div>
          </div>
        </div>
        
        <!-- 第三层：三个模块 -->
        <div class="modules_row">
          <div
            v-for="(module, index) in modules.slice(5, 8)"
            :key="index + 5"
            class="module_item"
            @mouseenter="setCurrentModule(module)"
            @mouseleave="resetCurrentModule"
          >
            <div class="module_icon">
              <img :src="module.icon" :alt="module.title" />
            </div>
            <div class="module_title">{{ module.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        currentModule: {},
        modules: [
          {
            title: '智慧园区',
            icon: require('@/assets/img/home/solution/zhihuiyuanqu.png'),
            description: ['瑞谦智慧园区解决方案以“以人为本，绿色高效，业务增值”的目标，利用物联网、大数据、人工智能等技术，搭建一体可视化综合管理平台...']
          },
          {
            title: '智慧社区',
            icon: require('@/assets/img/home/solution/zhihuishequ.png'),
            description: ['瑞谦智慧社区解决方案以“互联网+”为基础，社区服务、智能家居为核心，围绕社区安全、生活娱乐、物业管理、医疗教育等需求，借助物联网、人工智能、大数据等新技术，把物业服务、安防管理、社区民生服务等集成在一个社区运营平台。']
          },
          {
            title: '智慧学校',
            icon: require('@/assets/img/home/solution/zhihuixuexiao.png'),
            description: ['瑞谦智慧校园解决方案以校园安全为核心，运用视频识别分析、物联网、大数据等技术，结合视频监控、校园出入口管理、周界安防等系统，构建具有丰富的报警联动功能的校园智慧安防...']
          },
          {
            title: '认知智能',
            icon: require('@/assets/img/home/solution/renzhizhineng.png'),
            description: [
              ' 理解：语言、图像、视频、理解 ',
              ' 知识：知识表示与逻辑推理 ',
              '交互：问答、对话、聊天等 ',
              '决策：效用函数，贝叶斯决策理论等 ',
              ' 创造：语言、语音、图像自动生成 ',
              '学习：迁移学习、非监督学习、增强学习'
            ]
          },
          {
            title: '感知智能',
            icon: require('@/assets/img/home/solution/zhihuixuexiao.png'),
            description: ['瑞谦智慧社区解决方案以“互联网+”为基础，社区服务、智能家居为核心，围绕社区安全、生活娱乐、物业管理、医疗教育等需求，借助物联网、人工智能、大数据等新技术，把物业服务、安防管理、社区民生服务等集成在一个社区运营平台']
          },
          {
            title: '机器学习',
            icon: require('@/assets/img/home/solution/jiqixuexi.png'),
            description:
              ['专门研究计算机怎样模拟或实现人类的学习行为，以获取新的知识或技能，重新组织已有的知识结构使之不断改善自身的性能。']
          },
          {
            title: '云计算',
            icon: require('@/assets/img/home/solution/yunjisuan.png'),
            description: ['是指通常使用很多处理器或者某一集群中组织的几台计算机的计算系统和环境。']
          },
          {
            title: '大数据',
            icon: require('@/assets/img/home/solution/dashuju.png'),
            description: ['是需要新处理模式才能具有更强的决策力、洞察发现力和流程优化能力来适应海量、高增长率和多样化的信息资产。']
          }
        ],
        hidden: true,
      }
    },
    methods: {
      setCurrentModule(module) {
        this.currentModule = module;
        this.hidden = !this.hidden;
      },
      resetCurrentModule() {
        this.currentModule = {}
        this.hidden = !this.hidden;
      }
    }

  }
</script>

<style scoped lang="scss">
.scheme_wrap {
  width: 100%;
  height: 757px;   // 待定高度，实际需要子容器撑起父容器高度
  background-image: url(../../../assets/img/home/solution/bg.jpg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

.title_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 94%;
  max-width: 1320px;
  margin: 30px auto 0;
  .title_1 {
    line-height: normal;
    font-size: 60px;
    color: rgba(255,255,255,0.06);
    text-align: center;
    font-weight: bold;
    @media screen and (max-width: 768px) {
      font-size: 30px;
    }
  }
  .title_2 {
    line-height: normal;
    font-size: 30px;
    font-weight: normal;
    color: rgba(255,255,255,1);
    text-align: center;
    margin-top: -30px;
    @media screen and (max-width: 768px) {
      font-size: 24px;
      margin-top: -20px;
    }
  }
  .title_3 {
    border-top-style: solid;
    border-top-width: 2px;
    border-top-color: rgba(255,255,255,1);
    width: 56px;
    margin: 16px auto 30px auto;
    @media screen and (max-width: 768px) {
      margin: 10px auto 20px auto;
    }
  }
}

.content_container {
  display: flex;
  width: 94%;
  max-width: 1320px;
  margin: 0 auto;
  padding: 40px 0;
  gap: 60px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
    padding: 20px 0;
  }
}

.detail_content {
  flex: 0 0 40%;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 40px;
  color: white;

  @media screen and (max-width: 768px) {
    padding: 20px;
  }

  .detail_title {
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #ffffff;

    @media screen and (max-width: 768px) {
      font-size: 24px;
      margin-bottom: 15px;
    }
  }

  .detail_description {
    font-size: 18px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.9);
    margin: 0;

    @media screen and (max-width: 768px) {
      font-size: 16px;
    }
  }
}

.modules_container {
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media screen and (max-width: 768px) {
    gap: 15px;
  }
}

.modules_row {
  display: flex;
  gap: 20px;

  @media screen and (max-width: 768px) {
    gap: 15px;
    flex-wrap: wrap;
  }
}

.modules_row_center {
  justify-content: center;
}

.module_item {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 200px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 1);
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  }

  @media screen and (max-width: 768px) {
    padding: 15px;
  }

  .module_icon {
    width: 60px;
    height: 60px;
    margin-bottom: 10px;

    @media screen and (max-width: 768px) {
      width: 40px;
      height: 40px;
      margin-bottom: 8px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .module_title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    text-align: center;

    @media screen and (max-width: 768px) {
      font-size: 14px;
    }
  }
}
.hidden {
  visibility: hidden; // 隐藏元素，但保留空间
}

</style>

